import filters from 'constants/filters';
import tableNames from 'constants/tableNames';

export default {
  payments: [filters.paymentHotCurrency],
  payouts: [filters.currencies],
  moto: [
    filters.currencies,
    filters.motoType,
    { name: filters.motoPaymentProject, offset: 999 },
  ],
  financeRealTime: ['balanceType', 'balanceCompany', 'balanceContract'],
  financeStatement: [
    'balanceType',
    'balanceCompany',
    'balanceContract',
    'balance',
    'balanceCurrency',
  ],
  currencyRates: ['currency', 'userMerchant'],
  profile: [filters.currencies, 'contactLanguage', 'interfaceLanguage'],
  remittancePayments: ['remittanceTransferCurrency'],
  remittanceRecipientAccountsBuilder: [
    'country',
    'remittanceCountry',
    'remittanceTransferCurrency',
    'remittanceProject',
  ],
  myTeam: ['userStatus'],
  admin: ['userStatusAdmin', 'roleToSee', 'wlList', 'project', 'merchant'],
  userBuilder: [
    'roleToSee',
    'roleToGrant',
    'roleWithPermissionToGrant',
    'userActiveLegalEntity',
  ],
  userBuilderAdmin: [
    'roleToSee',
    'roleToGrant',
    'roleWithPermissionToGrant',
    'wlList',
    'project',
    'merchant',
    'legalEntity',
  ],
  invoices: ['currency', 'invoiceStatus', 'enabledProject'],
  invoicesCreate: ['currency', 'motoType'],
  recurringSettings: ['subscriptionPaymentPeriod'],
  recurring: ['paymentHotCurrency'],
  reportsBuilder: [
    'reportTemplateIntervalBy',
    'reportType',
    'reportTemplateLimits',
    'balanceUser'
  ],
  reports: ['reportType'],
  chargebacks: ['enabledProject'],
  chargebackCard: ['chargebackType'],
  [tableNames.fraud]: ['enabledProjectExternal'],
  [tableNames.rcs]: [
    'enabledProjectExternal',
    'userMerchant',
    'rcsContentType',
  ],
  projects: [
    'paymentMethodChannels',
    'paymentMethodStatuses',
    'paymentMethodOptions',
    'settingHistoryAction',
    'redirectUrlMode',
    'projectCallbackSettings',
    'paymentPageMerchantReturnState',
  ],
  userNotifications: ['userNotificationCategories', 'userNotificationTypes'],
  advancedAnalytics: [
    'enabledProject',
    'country',
    'paymentMethodType',
    'currency',
    'analyticsBrand',
    'paymentMethodFromDictionary',
    'issuerBank',
  ],
  help: ['feature'],
  [tableNames.settlements]: [
    'userMerchant',
    'currency',
    'settlementStatus',
    'settlementBalanceUser'
  ],
  [tableNames.balanceManage]: [
    'currency',
    'balanceType',
  ]
};
